/**
 * Image files from a paste or a drop. Text paste returns an empty list, so a paste into the note is
 * left entirely to the browser (spec section 8.5).
 */
export function imagesFromClipboard(data: DataTransfer | null): File[] {
  if (!data) return [];
  const fromItems = Array.from(data.items ?? [])
    .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null);
  if (fromItems.length > 0) return fromItems;
  return Array.from(data.files ?? []).filter((f) => f.type.startsWith('image/'));
}

export function imagesFromDrop(data: DataTransfer | null): File[] {
  if (!data) return [];
  return Array.from(data.files ?? []).filter((f) => f.type.startsWith('image/'));
}

/** True when a drag carries files (the only drag the panel reacts to). */
export function dragHasFiles(data: DataTransfer | null): boolean {
  return !!data && Array.from(data.types ?? []).includes('Files');
}
